// Singular, recruiter-facing label for an MVR finding type. Shared between
// AiFlagsPill's pre-engine code (now consumed only by the rules) and the
// engine's tooltip-row builders.
export const mvrFindingTypeLabel = (findingType: string): string => {
  switch (findingType) {
    case 'ACCIDENT':
      return 'Accident'
    case 'VIOLATION_MOVING':
      return 'Moving violation'
    case 'VIOLATION_NON_MOVING':
      return 'Non-moving violation'
    case 'SUSPENSION':
      return 'Suspension'
    case 'DISQUALIFICATION':
      return 'Disqualification'
    case 'LICENSE_ACTION':
      return 'License action'
    default:
      return findingType
  }
}
